export default __webpack_public_path__ + "static/media/iconUser.cafbcd70.svg";